import { useMemo } from "react";

import { useApiQuery } from "@/api";
import useCurrentEnvironment from "@/hooks/use-environment";
import { UnifiedTrackerRow, UnifiedWtmReportResponse } from "../types";

export function parseUnifiedTrackerRow(
  row: UnifiedTrackerRow,
): UnifiedTrackerRow {
  return {
    ...row,
    domains: row.domains ?? [],
    pageResolutionCount: row.pageResolutionCount ?? 0,
    firstDetectedAt: row.firstDetectedAt ? new Date(row.firstDetectedAt) : null,
    lastDetectedAt: row.lastDetectedAt ? new Date(row.lastDetectedAt) : null,
  };
}

function parseUnifiedWtmReport(
  data: UnifiedWtmReportResponse,
): UnifiedWtmReportResponse {
  return { rows: (data.rows ?? []).map(parseUnifiedTrackerRow) };
}

export default function useFetchUnifiedWtmReport(options?: {
  enabled?: boolean;
}) {
  const environment = useCurrentEnvironment();

  const result = useApiQuery(["get_unified_wtm_report", {}], {
    enabled: (options?.enabled ?? true) && !!environment?.ID,
    retry: (failureCount, error) => {
      if (failureCount >= 2) {
        return false;
      }
      return (error as { retryable?: boolean }).retryable !== false;
    },
  });

  const data = useMemo(
    () => (result.data ? parseUnifiedWtmReport(result.data) : result.data),
    [result.data],
  );

  return { ...result, data };
}
